// Document downloading util which allows a user to download a document via a presigned url API call
//   The fileName is what the document will be called via the download
export const downloadDocument = async (
  presigned_url: string,
  fileName: string,
  extension?: string
) => {
  const response = await fetch(new Request(presigned_url));
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${fileName || "Document"}${extension || ""}`);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
};
